import axios from 'axios';

import { publicAxiosHeader, getV1RootUrl } from 'common/helpers/apiHelper';

export const getForWeb = () =>
  axios.get(
    `${getV1RootUrl()}/setting/for-web?version=V1`,
    publicAxiosHeader()
  );
